import $ from "jquery";
import Flickity from "flickity";
import AsNavFor from "flickity-as-nav-for";
import "../vendors/flickity-imagesloaded/flickity-imagesloaded.js";

// class PartnersSlider {
//     constructor($el) {
//         this.$el = $el;
//         this.$sliderPartners = this.$el.find('.section-partners__content__slider');
//         console.log(this.$sliderPartners);
//         // this.$sliderThumbnails = this.$el.find('.section-partners__thumbnail-slider');

//         this.optionsPartners = {
//             // autoPlay: true,
//             wrapAround: true,
//             fade: true,
//             prevNextButtons: false,
//             freeScroll: true,
//             cellSelector: '.section-partners__content__slider__partner',
//         };

//         // this.optionsThumbnails = {
//         //     // autoPlay: true,
//         //     asNavFor: '.section-partners__content__slider',
//         //     wrapAround: true,
//         //     fade: true,
//         //     prevNextButtons: false,
//         //     freeScroll: true,
//         //     cellSelector: '.section-partners__thumbnail-slider__single',
//         // };

//         if(this.$el.length) {
//             this._init();
//         }
//     }

//     _init() {
//         this.$slides = this.$el.find('.section-partners__content__slider__partner');
//         this.slidesCount = this.$slides.length;

//         if(this.slidesCount > 0) {
//             this._createSliderPartners();
//             // this._createSliderThumbnails();
//         }
//     }

// 	_createSliderPartners() {
//         new Flickity(this.$sliderPartners, this.optionsPartners);
//     }

//     // _createSliderThumbnails() {
//     //     new Flickity(this.$sliderThumbnails[0], this.optionsThumbnails);
//     // }
// }

// $('.section-partners__content__slider').flickity({
//     // autoPlay: true,
//     wrapAround: true,
//     fade: true,
//     prevNextButtons: false,
//     freeScroll: true,
//     cellSelector: '.section-partners__content__slider__partner',
// });

// $(document).ready(function(){
//     $('.section-partners__content__slider').flickity();
// });

var sliderPartner = document.querySelector('#section-partners__content__slide');
if (typeof(sliderPartner) != 'undefined' && sliderPartner != null) {
    var flkty = new Flickity( sliderPartner, {
        // autoPlay: true,
        wrapAround: true,
        fade: true,
        prevNextButtons: true,
        freeScroll: true,
        pageDots: false,
        adaptiveHeight: true,
        cellSelector: '.section-partners__content__slider__partner',
        arrowShape: { 
            x0: 10,
            x1: 50, y1: 30,
            x2: 55, y2: 30,
            x3: 15
        },
    });

    var sliderThumbnail = document.querySelector('#section-partners__thumbnail-slide');
    var flkty2 = new Flickity( sliderThumbnail, {
        cellAlign: 'left',
        autoPlay: true,
        wrapAround: true,
        fade: true,
        prevNextButtons: false,
        freeScroll: true,
        asNavFor: $('.section-partners__content__slider')[0],
        pageDots: false,
        cellSelector: '.section-partners__thumbnail-slider__single',
    });
}

// export default PartnersSlider;
